import type { ReactNode } from 'react';

export const symbol_file_download_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m792-83-78-77H220q-24 0-42-18t-18-42v-113q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v113h434L521-353l-20 19q-5 5-9.5 7t-11.5 2q-6.96 0-11.48-2-4.52-2-9.75-7.23L308-485q-9-9-8-22t9-21q7-7 14.5-8t16.5 1L83-792q-9-9-9-21.53 0-12.52 9.05-21.36 8.3-8.11 21.13-8.11 12.82 0 21.82 8l709 710q8 8.31 8 21.16 0 12.84-8.3 20.97Q825.65-74 812.82-74 800-74 792-83ZM652-529q9 9 9 22.22 0 13.22-9 21.78l-24 24q-9 9-22 9t-22-9q-9-9-8.5-22t9.5-22l24-24q9-9 21.5-9t21.5 9ZM501.5-791.38q8.5 8.63 8.5 21.38v162q0 14.87-9.32 21.94-9.32 7.06-20.5 7.06t-20.68-7.25Q450-593.5 450-608v-162q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62Z"
		/>
	</svg>
);
